<template>
  <div class="sidebar ant-pro-sidebar">
    <div class="logo">
      <img src="@/assets/logo.png" alt="Logo" class="logo-img" />
      <span class="logo-text">大气校正管理系统</span>
    </div>

    <el-menu
      :default-active="activeMenu"
      class="sidebar-menu"
      background-color="#ffffff"
      text-color="#1f2937"
      active-text-color="#409EFF"
      router
    >
      <el-menu-item index="/admin/dashboard">
        <el-icon>
          <DataLine />
        </el-icon>
        <template #title>仪表盘</template>
      </el-menu-item>

      <el-menu-item index="/admin/userquery">
        <el-icon>
          <Timer />
        </el-icon>
        <template #title>用户使用查询</template>
      </el-menu-item>

      <el-menu-item index="/admin/image-stats">
        <el-icon>
          <Picture />
        </el-icon>
        <template #title>影像处理详情</template>
      </el-menu-item>

      <!-- 统计分析 -->
      <el-sub-menu index="/admin/stats">
        <template #title>
          <el-icon>
            <TrendCharts />
          </el-icon>
          <span>统计分析</span>
        </template>
        <el-menu-item index="/admin/stats/download">
          <el-icon>
            <Download />
          </el-icon>
          <template #title>软件下载量趋势</template>
        </el-menu-item>
        <el-menu-item index="/admin/stats/user-growth">
          <el-icon>
            <User />
          </el-icon>
          <template #title>用户增长趋势</template>
        </el-menu-item>
        <el-menu-item index="/admin/stats/active-users">
          <el-icon>
            <UserFilled />
          </el-icon>
          <template #title>活跃度统计</template>
        </el-menu-item>
        <!-- <el-menu-item index="/admin/stats/usage-time">
          <el-icon>
            <Timer />
          </el-icon>
          <template #title>使用时长统计</template>
        </el-menu-item> -->
        <el-menu-item index="/admin/stats/user-info">
          <el-icon>
            <Monitor />
          </el-icon>
          <template #title>用户信息统计</template>
        </el-menu-item>
      </el-sub-menu>

      <!-- 用户管理 -->
      <el-sub-menu index="/admin/users">
        <template #title>
          <el-icon>
            <UserFilled />
          </el-icon>
          <span>用户管理</span>
        </template>
        <el-menu-item index="/admin/users/list">
          <el-icon>
            <List />
          </el-icon>
          <template #title>用户列表</template>
        </el-menu-item>
        <el-menu-item index="/admin/users/audit">
          <el-icon>
            <Check />
          </el-icon>
          <template #title>用户审核</template>
        </el-menu-item>
        <el-menu-item index="/admin/users/feedback">
          <el-icon>
            <ChatDotRound />
          </el-icon>
          <template #title>用户反馈</template>
        </el-menu-item>
        <!-- <el-menu-item index="/admin/users/roles">
          <el-icon>
            <UserFilled />
          </el-icon>
          <template #title>角色管理</template>
        </el-menu-item>
        <el-menu-item index="/admin/users/permissions">
          <el-icon>
            <Lock />
          </el-icon>
          <template #title>权限管理</template>
        </el-menu-item>
        <el-menu-item index="/admin/users/logs">
          <el-icon>
            <Document />
          </el-icon>
          <template #title>操作日志</template>
        </el-menu-item>
        <el-menu-item index="/admin/users/settings">
          <el-icon>
            <Setting />
          </el-icon>
          <template #title>用户设置</template>
        </el-menu-item> -->
      </el-sub-menu>

      <!-- 内容管理 -->
      <el-sub-menu index="/admin/content">
        <template #title>
          <el-icon>
            <Collection />
          </el-icon>
          <span>内容管理</span>
        </template>
        <el-menu-item index="/admin/content/case">
          <el-icon>
            <Document />
          </el-icon>
          <template #title>案例管理</template>
        </el-menu-item>
        <el-menu-item index="/admin/content/tutorial">
          <el-icon>
            <Reading />
          </el-icon>
          <template #title>教程管理</template>
        </el-menu-item>
        <el-menu-item index="/admin/content/version">
          <el-icon>
            <Collection />
          </el-icon>
          <template #title>版本管理</template>
        </el-menu-item>
        <el-menu-item index="/admin/content/new">
          <el-icon>
            <News />
          </el-icon>
          <template #title>新闻管理</template>
        </el-menu-item>
      </el-sub-menu>
      <!-- 入群二维码 -->
      <el-menu-item index="/admin/qrcode">
        <el-icon>
          <PictureFilled />
        </el-icon>
        <template #title>入群二维码</template>
      </el-menu-item>

      <!-- 系统设置 -->
      <!-- <el-menu-item index="/admin/settings">
        <el-icon><Setting /></el-icon>
        <template #title>系统设置</template>
      </el-menu-item>-->
    </el-menu>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import {
  DataLine,
  Timer,
  Picture,
  Monitor,
  User,
  UserFilled,
  List,
  Check,
  ChatDotRound,
  Document,
  Lock,
  Setting,
  Tools,
  PictureFilled,
  Upload,
  Collection,
  Reading,
  Download
} from "@element-plus/icons-vue";

const route = useRoute();

// 计算当前激活的菜单项
const activeMenu = computed(() => {
  return route.path;
});
</script>

<style scoped>
.sidebar.ant-pro-sidebar {
  width: 240px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  color: #1f2937;
  border-right: 1px solid #f0f0f0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  font-family: "FangSong", "Source Han Sans CN", sans-serif;
  position: relative;
  overflow: hidden;
}

.logo {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}

.logo-img {
  height: 48px;
  width: auto;
  margin-right: 12px;
}

.logo-text {
  font-family: "STZhongsong", "SimSun", serif;
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
}

.sidebar-menu {
  flex: 1;
  border-right: none;
  background: #ffffff;
  padding: 16px 12px;
  overflow-y: auto;
  overflow-x: hidden;
}

/* 自定义滚动条样式 */
.sidebar-menu::-webkit-scrollbar {
  width: 6px;
}

.sidebar-menu::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.sidebar-menu::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.sidebar-menu::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.sidebar-menu :deep(.el-menu-item),
.sidebar-menu :deep(.el-sub-menu__title) {
  height: 48px;
  line-height: 48px;
  border-radius: 6px;
  margin: 4px 8px;
  font-family: "STZhongsong", "SimSun", serif;
  font-size: 20px;
  color: #1f2937;
  transition: all 0.3s ease;
  font-weight: 600;
}

.sidebar-menu :deep(.el-menu-item.is-active) {
  background: #f0f5ff !important;
  color: #409eff !important;
  font-weight: 700;
}

.sidebar-menu :deep(.el-menu-item:hover) {
  background: #f0f5ff !important;
  color: #409eff !important;
}

.sidebar-menu :deep(.el-sub-menu__title:hover) {
  background: #f0f5ff !important;
  color: #409eff !important;
}

.sidebar-menu :deep(.el-sub-menu.is-active .el-sub-menu__title) {
  color: #409eff !important;
  font-weight: 700;
}

.sidebar-menu :deep(.el-menu-item .el-icon),
.sidebar-menu :deep(.el-sub-menu__title .el-icon) {
  width: 24px;
  height: 24px;
  font-size: 20px;
  color: #1f2937;
  transition: all 0.3s ease;
  margin-right: 8px;
}

.sidebar-menu :deep(.el-menu-item.is-active .el-icon),
.sidebar-menu :deep(.el-sub-menu.is-active .el-sub-menu__title .el-icon) {
  color: #409eff;
}

/* 二级菜单样式 */
.sidebar-menu :deep(.el-sub-menu .el-menu) {
  background: #ffffff !important;
  padding: 4px 0;
}

.sidebar-menu :deep(.el-sub-menu .el-menu-item) {
  min-width: 0;
  height: 40px;
  line-height: 40px;
  padding-left: 48px !important;
  margin: 2px 8px;
  font-family: "Source Han Serif CN", "SimSun", serif;
  font-size: 18px;
  color: #666666;
  background: #ffffff !important;
  font-weight: 300;
}

.sidebar-menu :deep(.el-sub-menu .el-menu-item:hover) {
  background: #f0f5ff !important;
  color: #409eff !important;
}

.sidebar-menu :deep(.el-sub-menu .el-menu-item.is-active) {
  background: #f0f5ff !important;
  color: #409eff !important;
  font-weight: 500;
}

.sidebar-menu :deep(.el-sub-menu .el-menu-item .el-icon) {
  width: 20px;
  height: 20px;
  font-size: 18px;
  margin-right: 8px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sidebar.ant-pro-sidebar {
    position: fixed;
    z-index: 1000;
    transform: translateX(-100%);
  }

  .sidebar.ant-pro-sidebar.show {
    transform: translateX(0);
  }

  .logo-text {
    font-size: 20px;
  }

  .sidebar-menu :deep(.el-menu-item),
  .sidebar-menu :deep(.el-sub-menu__title) {
    font-size: 18px;
  }
}
</style>
